import $ from '../_snowpack/pkg/jquery.js';
import Auth from './auth.js';
import Bookmark from './bookmark.js';

const Users = {
  me: {},
  users: [],
  init: async function(uid, click) {
    if (uid) {
      this.users = await this.get();
      this.me = await fetch(`https://us-central1-hipster-d0adb.cloudfunctions.net/getUser?uid=${uid}`).then(response => response.json());
      this.users = this.users.filter(u => u.uid !== uid);
      $('.bookmark-nav').show();
      $('.bookmark-content ul').html(`
        <li class="me-container" data-id="${this.me.uid}">
          <img src="${this.me.image ?? './assets/logo.png' }" />
          <div>
            <h4>${this.formatName(this.me.name)} (you)</h4>
          </div>
          <i class='btr bt-gear'></i>
          <button type="button" class="signout">Logout</button>
        </li>`);
      this.users.sort((a, b) => a.name.localeCompare(b.name)).forEach(user => {
        const image = user.image ?? '/assets/logo.png';
        const spotIds = user.bookmarks.map(o => o.spot);
        const matches = Bookmark.bookmarks.filter(bookmark => spotIds.includes(bookmark.place_id));
        const text = matches.length ? `You have ${this.pluralize(matches.length, 'spot')} in common` : 'You don\'t have any spots in common';
        const matchesHTML = matches.map((match) => `<h5 class="${match.place_id}" data-id="${match.place_id}">${match.spotName}</h5><br />`).join('');
        user.matches = matches;
        $('.bookmark-content .bookusers').append(`
          <li>
            <div data-id="${user.uid}" class="user-wrapper ${matches.length ? '' : 'no-matches'}">
              <img src="${image}" />
              <div>
                <h4>${this.formatName(user.name)}</h4>
                <p>${text}</p>
              </div>
              <i class="btr bt-caret-up"></i>
            </div>
            <div class="common-spots hidden">${matchesHTML}</div>
          </li>
        `);
      });
      if (!click) this.clickHandler();
      $('.me-container').on('click', '.signout', () => Auth.signout());
    }
  },
  get: async function() {
    const users = await fetch('https://us-central1-hipster-d0adb.cloudfunctions.net/getUsers').then(response => response.json());
    const bookmarks = await fetch('https://hipster.io/api/bookmark').then(response => response.json());
    return users.map(u => ({ ...u, bookmarks: bookmarks.filter(b => b.user === u.uid) }));
  },
  clickHandler: function() {
    const that = this;
    $('.bookmark-content').on('click', '.bookusers .user-wrapper', function() {
      if ($(this).hasClass('no-matches')) return;
      const uid = $(this).data('id');
      const user = that.users.find((u) => u.uid === uid);
      $(this).next('.common-spots').slideToggle();
      $(this).find('.bt-caret-up').toggleClass('flip');
      //window.updateMarkers(user.matches);
      const [name] = user.name.split(' ');
      $('.imglogo span').text(`You and ${name}`);
    });

    $('.bookmark-content').on('click', '.bookusers h5', function() {
			if(window.innerWidth<700){
				$('.bt-minus').click();
			}

    	$('.bookusers h5').removeClass('activity');
    	$(this).addClass('activity');
      window.onMarkerClick({ target: { id: $(this).data('id') }}, true);
    });
  },
  pluralize: ((count, noun, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`),
  formatName: (name) => {
    if (!name.trim().includes(' ')) return name;
    const names = name.split(' ');
    const lastName = names.pop();
    return `${names.join('')} ${lastName.charAt(0).toUpperCase()}.`;
  }
}
export default Users;
